import * as DialogPrimitive from "@radix-ui/react-dialog";
import { XIcon } from "lucide-react";
import { DialogContent } from "@/components/ui/dialog";
import { cn } from "@/utils/css";

export const LoadboardModal = ({
    title,
    buttonClassName,
    buttonDisabled,
    buttonChildren,
    children,
    open,
    onOpenChange,
    usePortal = true,
    contentClassName,
    headerClassName,
    closeButtonClassName,
}) => {
    const content = (
        <DialogContent
            className={cn("bg-cm-p-surface w-[383px] flex flex-col p-4 pt-3 gap-5", contentClassName)}
            usePortal={usePortal}
            aria-describedby={undefined}
        >
            <div className={cn("w-full flex items-center justify-between h-10", headerClassName)}>
                <DialogPrimitive.Title className="text-lg font-medium">{title}</DialogPrimitive.Title>
                <div className="flex items-center justify-center w-10 h-10">
                    <DialogPrimitive.Close asChild>
                        <button
                            type="button"
                            className={cn("w-10 h-10 inline-flex items-center justify-center", closeButtonClassName)}
                        >
                            <XIcon className="w-5 h-5" />
                        </button>
                    </DialogPrimitive.Close>
                </div>
            </div>
            <div className="w-full">{children}</div>
        </DialogContent>
    );

    return (
        <div>
            <DialogPrimitive.Root open={open} onOpenChange={onOpenChange}>
                {buttonChildren ? (
                    <form>
                        {content}
                        <DialogPrimitive.Trigger asChild>
                            <button type="button" disabled={buttonDisabled} className={buttonClassName} onClick={(e) => e.stopPropagation()}>
                                {buttonChildren}
                            </button>
                        </DialogPrimitive.Trigger>
                    </form>
                ) : (
                    content
                )}
            </DialogPrimitive.Root>
        </div>
    );
};
